const dict = {
  "nav_group_overview": "Visão geral",
  "nav_group_sales": "Vendas",
  "nav_group_customers": "Clientes",
  "nav_group_service": "Serviço e Qualidade",
  "nav_group_contracts": "Contratos",
  "nav_group_operations": "Operações",
  "nav_group_insights": "Insights",
  "nav_group_ki": "IA",
  "nav_group_purchasing": "Compras",
  "nav_sub_suppliers": "Fornecedores",
  "nav_sub_procurement": "Aquisições",
  "nav_sub_quality": "Qualidade",
  "nav_sub_analytics": "Análise e economias",
  "nav_sub_governance": "Governança e sistemas",
  "ki_menu": "Menu IA",
  "ki_costs": "Custos IA",
  "quote_comparison": "Comparação de ofertas IA",
  "my_access": "Meus direitos",
  "my_accounts_rights": "Minhas contas e direitos",
  "my_role": "Função / perfil",
  "visible_accounts": "Contas visíveis",
  "all_accounts_visible": "Você pode ver todas as contas",
  "active_grants": "Permissões temporárias ativas",
  "no_grants": "Sem permissões temporárias",
  "access_scope": "Âmbito de acesso",
  "field_permissions": "Permissões de campo",
  "roles_rights": "Funções e direitos",
  "reassign": "Reatribuir",
  "responsible_reps": "Comerciais responsáveis",
  "assignment_history": "Histórico de atribuição",
  "changed_by": "Alterado por",
  "effective_date": "Data efetiva",
  "bulk_assign": "Atribuição em massa",
  "add_grant": "Adicionar permissão",
  "grant_type": "Tipo",
  "deputy": "Substituição / férias",
  "exception": "Exceção",
  "valid_from": "Válido de",
  "valid_to": "Válido até",
  "reason": "Motivo",
  "access_log": "Registo de acesso",
  "access_deputy": "Acesso e substituição",
  "restricted_account": "Restrito — apenas dados básicos",
  "restricted_hint": "Você não está atribuído a esta conta. Os dados comerciais estão ocultos.",
  "role_profile": "Perfil de função",
  "account_visibility": "Visibilidade de contas",
  "vis_all": "Todas as contas",
  "vis_assigned": "Apenas atribuídas",
  "vis_team": "Atribuídas + equipa",
  "unassigned_view": "Contas não atribuídas",
  "unassigned_hidden": "Oculto",
  "unassigned_basic": "Apenas dados básicos",
  "see_revenue_qty": "Receita / quantidade",
  "see_wallet": "Wallet Share e concorrência",
  "see_visit_notes": "Notas de visita",
  "see_web_research": "Pesquisa externa",
  "see_ai_analysis": "Análise de conta (IA)",
  "can_reassign": "Pode reatribuir contas",
  "grants_deputy_help": "Acesso temporário às contas de um colega (ex.: substituição por férias). Expira automaticamente.",
  "manager": "Reporta a (Team Lead)",
  "key_accounts": "Key Accounts estratégicas",
  "no_access": "Sem acesso",
  "mode_replace": "Substituir",
  "mode_add": "Adicionar ao existente",
  "select_accounts": "Selecionar contas",
  "user": "Utilizador",
  "dashboard": "Painel",
  "accounts": "Clientes",
  "contacts": "Contactos",
  "leads": "Leads",
  "opportunities": "Oportunidades",
  "quotes": "Propostas",
  "complaints": "Reclamações",
  "admin": "Administração",
  "admin_settings": "Configurações",
  "search_placeholder": "Pesquisar clientes, contactos, oportunidades…",
  "new": "Novo",
  "logout": "Terminar sessão",
  "notifications": "Notificações",
  "mark_all_read": "Marcar tudo como lido",
  "no_notifications": "Sem notificações",
  "save": "Guardar",
  "cancel": "Cancelar",
  "delete": "Eliminar",
  "edit": "Editar",
  "create": "Criar",
  "close": "Fechar",
  "export_csv": "Exportar CSV",
  "import_csv": "Importar CSV",
  "records": "registos",
  "actions": "Ações",
  "name": "Nome",
  "company": "Empresa",
  "account": "Cliente",
  "owner": "Responsável",
  "status": "Estado",
  "stage": "Fase",
  "amount": "Valor",
  "probability": "Probabilidade",
  "segment": "Segmento",
  "segments": "Segmentos",
  "add": "Adicionar",
  "segments_help": "Gerir a lista de segmentos para clientes e fábricas. Renomear atualiza todos os registos atribuídos.",
  "segment_name": "Nome do segmento",
  "segment_renamed": "Segmento renomeado ✓",
  "segment_deleted": "Segmento eliminado ✓",
  "type": "Tipo",
  "email": "E-mail",
  "phone": "Telefone",
  "mobile": "Telemóvel",
  "title_field": "Cargo",
  "department": "Departamento",
  "buying_role": "Função no buying center",
  "source": "Origem",
  "score": "Score",
  "severity": "Gravidade",
  "defect_category": "Categoria do defeito",
  "claimed_value": "Valor reclamado",
  "date_received": "Data de receção",
  "sla": "SLA",
  "overdue": "Em atraso",
  "convert": "Converter",
  "converted": "Convertido",
  "product_type": "Tipo de produto",
  "print_technology": "Tecnologia de impressão",
  "substrate": "Substrato / material",
  "finishing": "Acabamento",
  "business_type": "Tipo de negócio",
  "competitors": "Concorrentes",
  "close_reason": "Motivo ganho/perdido",
  "close_date": "Fecho previsto",
  "annual_volume": "Volume anual",
  "num_skus": "Nº SKUs",
  "num_colors": "Nº cores",
  "abc_class": "Classe ABC",
  "annual_spend": "Gasto anual em etiquetas",
  "payment_terms": "Condições de pagamento",
  "incoterm": "Incoterm",
  "credit_limit": "Limite de crédito",
  "vat_id": "NIF",
  "city": "Cidade",
  "billing_address": "Morada de faturação",
  "customer_since": "Cliente desde",
  "certifications": "Certificações",
  "region": "Região",
  "parent_account": "Empresa-mãe",
  "kanban": "Kanban",
  "table": "Tabela",
  "weighted_forecast": "Forecast ponderado",
  "aging_alert": "Sem atividade há 14+ dias",
  "total_pipeline": "Pipeline total",
  "weighted_pipeline": "Pipeline ponderada",
  "win_rate": "Win Rate",
  "avg_deal": "Dimensão média do negócio",
  "open_opps": "Oportunidades abertas",
  "pipeline_by_stage": "Pipeline por fase",
  "forecast_by_month": "Forecast por mês",
  "forecast_by_rep": "Forecast por comercial",
  "revenue_by_segment": "Receita por segmento",
  "top_opportunities": "Top 10 oportunidades",
  "open_complaints": "Reclamações abertas",
  "critical": "Crítico",
  "sla_compliance": "Cumprimento de SLA",
  "avg_resolution": "Dias médios de resolução",
  "pareto": "Reclamações por categoria (Pareto)",
  "trend_12m": "Tendência de reclamações",
  "by_severity": "Abertas por gravidade",
  "top_accounts_complaints": "Top 5 clientes por valor de reclamação",
  "revenue_ytd": "Receita YTD",
  "vs_py": "vs. ano anterior",
  "abc_distribution": "Distribuição ABC de clientes",
  "churn_risk": "Contas com risco de perda",
  "business_split": "Novo negócio vs. renovação",
  "sales_dash": "Vendas",
  "quality_dash": "Qualidade",
  "management_dash": "Direção",
  "comments": "Comentários",
  "audit_trail": "Histórico de alterações",
  "add_comment": "Adicionar um comentário…",
  "post": "Enviar",
  "quote_number": "Nº da proposta",
  "validity": "Válido até",
  "total": "Total",
  "margin": "Margem",
  "version": "Versão",
  "revise": "Nova versão",
  "download_pdf": "Descarregar PDF",
  "line_items": "Posições",
  "material": "Material",
  "width": "Largura",
  "height": "Altura",
  "quantity": "Quantidade",
  "unit_price": "Preço/1000",
  "tooling": "Ferramenta",
  "cost": "Custo/1000",
  "line_total": "Total da posição",
  "add_line": "Adicionar posição",
  "price_breaks": "Preços por escalão",
  "winding": "Bobinagem",
  "core_size": "Núcleo",
  "labels_per_roll": "Etiquetas/rolo",
  "d8_report": "Relatório 8D",
  "claimed_qty": "Quantidade reclamada",
  "accepted_value": "Valor aceite",
  "credit_note": "Nº da nota de crédito",
  "order_number": "Nº da encomenda",
  "article_number": "Nº do artigo",
  "received_via": "Recebido via",
  "costs": "Custos de reclamação",
  "cost_credit": "Nota de crédito",
  "cost_reprint": "Reimpressão",
  "cost_freight": "Transporte",
  "save_costs": "Guardar custos",
  "delete_file_confirm": "Eliminar este ficheiro?",
  "contact": "Contacto",
  "users": "Utilizadores",
  "picklists": "Listas de seleção",
  "role": "Função",
  "territory": "Território",
  "password": "Palavra-passe",
  "add_user": "Criar utilizador",
  "tags": "Etiquetas",
  "info": "Detalhes",
  "hierarchy": "Hierarquia",
  "children_accounts": "Subsidiárias",
  "open_opp_value": "Valor de oportunidades abertas",
  "avg_margin": "Margem média",
  "estimated_volume": "Volume anual estimado",
  "product_interest": "Interesse no produto",
  "possible_duplicate": "Possível duplicado encontrado",
  "login_title": "Iniciar sessão no Encasa",
  "login_sub": "CRM e SRM para fabricantes de embalagens",
  "recently_viewed": "Vistos recentemente",
  "no_results": "Sem resultados",
  "loading": "A carregar…",
  "empty_title": "Ainda não há nada aqui",
  "empty_cta": "Crie o seu primeiro registo para começar",
  "all_stages": "Todas as fases",
  "all": "Todos",
  "required_close_reason": "Selecione o motivo do fecho",
  "mark_won": "Ganha",
  "mark_lost": "Perdida",
  "quality": "Qualidade",
  "engagement": "Envolvimento (0-30)",
  "linkedin": "LinkedIn",
  "preferred_language": "Idioma preferido",
  "birthday": "Aniversário",
  "notes": "Notas",
  "shipping_addresses": "Moradas de envio",
  "trade_fair": "Feira",
  "activities": "Atividades",
  "calendar": "Calendário",
  "list_view": "Lista",
  "due_date": "Data-limite",
  "priority": "Prioridade",
  "subject": "Assunto",
  "date": "Data",
  "time": "Hora",
  "activity_type": "Tipo",
  "done": "Concluído",
  "open_status": "Aberto",
  "visit_report": "Relatório de visita",
  "attendees": "Participantes",
  "topics": "Temas",
  "agreements": "Acordos",
  "next_steps": "Próximos passos",
  "description": "Descrição",
  "tradefair": "Modo feira",
  "quick_capture": "Captura rápida de leads",
  "captured_leads": "Leads capturados",
  "save_next": "Guardar e próximo lead",
  "today": "Hoje",
  "my_only": "Apenas meus",
  "all_team": "Toda a equipa",
  "mark_done": "Marcar como concluído",
  "lead_saved": "Lead guardado",
  "samples": "Amostras e artes",
  "samples_tab": "Pedidos de amostra",
  "artworks": "Aprovações de arte",
  "sample_number": "Nº da amostra",
  "artwork_number": "Nº da arte",
  "requested_date": "Solicitado em",
  "tracking_number": "Nº de rastreio",
  "upload_pdf": "Carregar PDF",
  "view_pdf": "Ver PDF",
  "no_file": "Ainda sem ficheiro",
  "contracts": "Contratos",
  "contract_number": "Nº do contrato",
  "start_date": "Início",
  "end_date": "Fim",
  "annual_value": "Valor anual",
  "price_index": "Índice de preços",
  "index_base_value": "Valor base do índice",
  "indexation_threshold": "Limiar de indexação %",
  "indexation_clause": "Cláusula de indexação",
  "days_to_expiry": "Dias até expirar",
  "expiring_soon": "Expira em breve",
  "expired": "Expirado",
  "forecast": "Forecast e objetivos",
  "target": "Objetivo",
  "actual": "Real",
  "attainment": "Cumprimento",
  "burndown": "Objetivo vs. real (acumulado)",
  "monthly_comparison": "Objetivo vs. real mensal",
  "edit_targets": "Editar objetivos",
  "all_reps": "Todos os comerciais",
  "by_territory": "Por território",
  "site_match": "Correspondência de fábrica",
  "suggest_site": "Sugerir fábrica de produção",
  "best_press": "Melhor máquina",
  "match_missing": "Não coberto",
  "plants": "Fábricas e máquinas",
  "presses": "Máquinas de impressão",
  "technology": "Tecnologia",
  "max_colors": "Máx. cores",
  "web_width": "Largura da banda (mm)",
  "add_plant": "Criar fábrica",
  "add_press": "Adicionar máquina",
  "location": "Localização",
  "send_email": "Enviar por e-mail",
  "send_8d": "Enviar relatório 8D",
  "download_8d": "PDF relatório 8D",
  "recipient": "Destinatário",
  "message": "Mensagem",
  "send": "Enviar",
  "email_sent_ok": "E-mail enviado",
  "email_simulated": "E-mail simulado (SMTP não configurado)",
  "photos": "Fotos e ficheiros",
  "upload_photo": "Carregar ficheiro",
  "portal_users": "Acessos ao portal",
  "add_portal_user": "Criar acesso ao portal",
  "reports": "Relatórios",
  "report_name": "Nome do relatório",
  "run_report": "Executar",
  "save_report": "Guardar relatório",
  "shared": "Partilhado com a equipa",
  "add_filter": "Adicionar filtro",
  "field": "Campo",
  "operator": "Operador",
  "value": "Valor",
  "export_excel": "Exportar Excel",
  "my_reports": "Relatórios guardados",
  "columns": "Colunas",
  "locations": "Localizações",
  "site_type": "Tipo de local",
  "country": "País",
  "map_view": "Mapa",
  "erp_number": "Nº ERP local",
  "timezone": "Fuso horário",
  "lat": "Latitude",
  "lng": "Longitude",
  "account_manager": "Gestor de conta",
  "network": "Rede",
  "relationships": "Relações",
  "add_relationship": "Adicionar relação",
  "relationship_type": "Tipo de relação",
  "volume_pct": "% do volume",
  "contract_ref": "Ref. do contrato",
  "performance": "Desempenho",
  "otif": "OTIF",
  "on_time": "No prazo",
  "in_full": "Completo",
  "fill_rate": "Fill Rate",
  "lead_time": "Cumprimento de prazo",
  "complaint_rate": "Reclamações / 1000 encomendas",
  "forecast_accuracy": "Precisão do forecast",
  "share_of_wallet": "Share of Wallet",
  "dso": "DSO (dias)",
  "health_score": "Health",
  "days_late": "Dias de atraso",
  "scorecard": "Scorecard de cliente",
  "export_pdf": "Exportar PDF",
  "duplicates": "Duplicados",
  "merge": "Unir",
  "link_as_network": "Ligar como rede",
  "confidence": "Confiança",
  "pick_survivor": "Escolher registo sobrevivente",
  "merged_ok": "Registos unidos",
  "user_location_matrix": "Matriz utilizador-localização",
  "weekly_digest": "Resumo semanal",
  "send_test": "Enviar teste para…",
  "send_now": "Enviar agora a todos os comerciais",
  "digest_enabled": "Envio automático às segundas às 07:00",
  "preview": "Pré-visualização",
  "perm_groups": "Grupos de permissões",
  "add_group": "Criar grupo",
  "module_rights": "Direitos de módulo",
  "default_right": "Direito predefinido",
  "margins_visible": "Margens visíveis",
  "scoped_label": "Visibilidade por localização",
  "orders_12m": "Encomendas (12M)",
  "no_kpi_data": "Ainda sem histórico de encomendas para este cliente",
  "qbr_package": "Pacote QBR (PDF)",
  "current_indexes": "Valores de índice atuais",
  "index_deviation": "Δ Índice",
  "index_alerts": "alertas de índice acionados",
  "renew": "Renovar",
  "renew_contract": "Renovar contrato",
  "renewed_from": "Renovado de",
  "duration_months": "Duração (meses)",
  "new_start_date": "Novo início",
  "new_end_date": "Novo fim",
  "contract_renewed": "Contrato renovado",
  "import_indexes": "Importar índices",
  "import_index_help": "Cole CSV ou carregue um ficheiro. Formatos: longo (date, index_name, value) ou largo (date, index-A, index-B, …). Separador e formato de data detetados automaticamente (ISO / DE / mês).",
  "paste_csv": "Colar dados CSV",
  "upload_file": "Carregar ficheiro",
  "or_upload": "ou carregar ficheiro",
  "target_index": "Índice-alvo (apenas para ficheiros de um valor)",
  "any_column": "Detetar automaticamente",
  "import_result": "Importado",
  "rows_skipped": "ignorado",
  "index_history": "Histórico de índices",
  "index_trend": "Tendência do índice de preços",
  "no_history_yet": "Ainda sem histórico – edite ou importe valores",
  "last_12m": "12 meses",
  "last_24m": "24 meses",
  "last_36m": "36 meses",
  "manual": "Entrada manual",
  "import": "Importar",
  "guide": "Guia",
  "guide_title": "Guia do Encasa CRM & SRM",
  "guide_subtitle": "Tudo para tirar o máximo da sua plataforma CRM e SRM — módulo a módulo.",
  "guide_intro": "Escolha um módulo abaixo para saber o que faz, ou reproduza novamente a visita guiada.",
  "start_tour": "Iniciar visita",
  "restart_tour": "Repetir visita guiada",
  "tour_skip": "Ignorar visita",
  "tour_next": "Seguinte",
  "tour_back": "Voltar",
  "tour_finish": "Concluir",
  "tour_step": "Passo",
  "greeting_morning": "Bom dia",
  "greeting_afternoon": "Boa tarde",
  "greeting_evening": "Boa noite",
  "todays_overview": "Aqui está o seu negócio de relance hoje.",
  "tour_welcome_title": "Bem-vindo ao Encasa CRM & SRM",
  "tour_welcome_body": "Faça uma breve visita de 60 segundos pelas áreas principais. Pode repeti-la quando quiser na página Guia.",
  "tour_nav_title": "Navegação principal",
  "tour_nav_body": "Salte entre todos os módulos — clientes, oportunidades, propostas, reclamações, contratos e mais.",
  "tour_search_title": "Pesquisa global",
  "tour_search_body": "Encontre instantaneamente clientes, contactos, oportunidades, propostas e reclamações a partir de qualquer lugar.",
  "tour_new_title": "Crie registos rapidamente",
  "tour_new_body": "Use o botão Novo para adicionar qualquer tipo de registo sem sair da página atual.",
  "tour_notif_title": "Notificações",
  "tour_notif_body": "Incumprimentos de SLA, contratos a expirar e lembretes de aprovação chegam todos aqui.",
  "tour_done_title": "Tudo pronto!",
  "tour_done_body": "Abra a página Guia quando quiser para ajuda detalhada sobre cada módulo.",
  "guide_desc_dashboard": "Painéis de vendas, qualidade e direção com KPIs em tempo real, pipeline, forecasts e risco de perda.",
  "guide_desc_accounts": "Vista 360° do cliente: hierarquia, certificações, KPIs, relações de rede e exportação QBR.",
  "guide_desc_locations": "Faça a gestão de fábricas/localizações com vista de mapa e filtro por região e tipo de local.",
  "guide_desc_contacts": "Contactos com ligações multicliente e funções do buying center.",
  "guide_desc_leads": "Scoring de leads e conversão num clique para cliente, contacto e oportunidade.",
  "guide_desc_opportunities": "Pipeline Kanban com arrastar e largar, forecast ponderado, alertas de antiguidade e correspondência de fábrica.",
  "guide_desc_quotes": "Propostas por posições com preços por escalão, margens, versionamento e exportação PDF.",
  "guide_desc_complaints": "Gestão de reclamações 8D com seguimento de SLA, escalonamento e registo de custos.",
  "guide_desc_samples": "Pedidos de amostra e aprovações de arte com carregamento de PDF real e fluxo de estados.",
  "guide_desc_contracts": "Contratos com cláusulas de índice de preços, fluxo de renovação e gráficos de tendência.",
  "guide_desc_activities": "Chamadas, reuniões, visitas e tarefas com um calendário de equipa partilhado.",
  "guide_desc_reports": "Construtor de relatórios com filtros, relatórios guardados e exportação para Excel.",
  "guide_desc_forecast": "Objetivos de território vs. reais com KPIs de cumprimento e gráficos burndown.",
  "guide_desc_tradefair": "Captura rápida de leads otimizada para telemóvel em feiras.",
  "guide_desc_admin": "Utilizadores, grupos de permissões, listas, fábricas, duplicados e definições do resumo.",
  "customer_forecast": "Forecast de cliente",
  "select_account": "Selecionar cliente",
  "fiscal_year": "Ano fiscal",
  "scope": "Nível",
  "customer_level": "Nível cliente (sem projeto)",
  "all_projects": "Todos (agregado)",
  "projects": "Projetos",
  "project": "Projeto",
  "new_project": "Novo projeto",
  "add_project": "Criar projeto",
  "project_name": "Nome do projeto",
  "link_opportunity": "Ligar oportunidade (opcional)",
  "no_opp_link": "Sem oportunidade",
  "delete_project": "Eliminar projeto",
  "project_deleted": "Projeto eliminado",
  "project_created": "Projeto criado",
  "metric": "Métrica",
  "revenue": "Receita",
  "month": "Mês",
  "fc_revenue": "Forecast receita",
  "actual_revenue": "Receita real",
  "fc_qty": "Forecast quantidade",
  "actual_qty": "Quantidade real",
  "total_forecast": "Forecast total",
  "total_actual": "Real total",
  "deviation": "Desvio",
  "save_forecast": "Guardar",
  "forecast_saved": "Forecast guardado",
  "forecast_vs_actual": "Forecast vs. real",
  "import_excel": "Importar Excel",
  "download_template": "Modelo",
  "import_done": "Linhas importadas",
  "aggregate_readonly": "A vista agregada é só de leitura — escolha um projeto ou o nível cliente para editar.",
  "guide_desc_customer_forecast": "Forecast mensal de cliente e projeto vs. real (receita + quantidade) com Excel.",
  "autofill_actuals": "Obter reais das encomendas",
  "autofilled": "Meses reais preenchidos",
  "no_autofill": "Não foram encontrados novos reais",
  "group": "Grupo",
  "group_rollup": "Resumo do grupo",
  "members": "Membros",
  "fillers": "Co-packers / enchedores",
  "global_cs": "Global Customer Service",
  "assign_global_cs": "Atribuir responsável global de CS",
  "cs_assigned": "Responsável global de CS atribuído",
  "group_complaints": "Reclamações do grupo",
  "total_members": "Membros",
  "no_cs_owner": "Não atribuído",
  "open_pipeline": "Pipeline aberto",
  "top_customer_forecast": "Top clientes · Forecast vs. real",
  "portal_quotes": "Propostas",
  "portal_artworks": "Aprovações de arte",
  "approve": "Aprovar",
  "reject": "Solicitar revisão",
  "decision_saved": "Decisão guardada",
  "add_note": "Nota (opcional)",
  "awaiting_decision": "A aguardar a sua decisão",
  "no_quotes_portal": "Ainda não há propostas disponíveis.",
  "no_artworks_portal": "Sem artes para rever.",
  "forecast_approvals": "Aprovações de forecast",
  "approval_status": "Aprovação",
  "submit_for_approval": "Submeter para aprovação",
  "fc_approve": "Aprovar",
  "fc_reject": "Rejeitar",
  "reject_reason": "Motivo da rejeição",
  "st_draft": "Rascunho",
  "st_submitted": "Em aprovação",
  "st_approved": "Aprovado",
  "st_rejected": "Rejeitado",
  "st_none": "Não submetido",
  "no_pending_approvals": "Sem forecasts pendentes de aprovação.",
  "submitted_by": "Submetido por",
  "pending_approval_hint": "Em aprovação (ainda não contabilizado como comprometido)",
  "approved_fc": "Aprovado",
  "pending_fc": "Em aprovação",
  "group_qbr": "QBR do grupo (PDF)",
  "submitted_ok": "Submetido para aprovação",
  "approved_ok": "Forecast aprovado",
  "rejected_ok": "Forecast rejeitado",
  "guide_desc_forecast_approvals": "Rever, aprovar ou rejeitar os forecasts de cliente submetidos pela equipa de vendas.",
  "history": "Histórico",
  "show_history": "Histórico",
  "no_history": "Ainda sem histórico.",
  "ev_submitted": "submetido",
  "ev_approved": "aprovado",
  "ev_rejected": "rejeitado",
  "send_reminders": "Enviar lembretes agora",
  "reminders_sent_msg": "Lembretes enviados",
  "lp_switch_normal": "Normal",
  "lp_switch_hero": "Modo Hero",
  "lp_eyebrow": "CRM e SRM para fabricantes de embalagens",
  "lp_title": "Vendas e compras numa só plataforma.",
  "lp_desc": "Clientes, pipeline, propostas e qualidade — mais gestão de fornecedores, verificação bancária de quatro olhos e compras. Uma plataforma para fabricantes de embalagens: etiquetas, shrink sleeves, embalagens flexíveis e cartonagem.",
  "lp_cta": "Iniciar sessão no Encasa",
  "lp_f1_t": "Vendas e propostas",
  "lp_f1_d": "Acompanhe o pipeline, gere propostas PDF e faça previsão de receita.",
  "lp_f2_t": "Compras e fornecedores",
  "lp_f2_d": "Dados mestre de fornecedores, controlo bancário de quatro olhos e compras.",
  "lp_f3_t": "Qualidade e KPIs",
  "lp_f3_d": "Reclamações 8D, scorecards, forecasts e relatórios QBR.",
  "lp_nav_signin": "Iniciar sessão",
  "lp_features_title": "Tudo para vendas e compras",
  "lp_features_sub": "Uma plataforma para todo o ciclo comercial — do lead à entrega, do fornecedor à fatura.",
  "lp_f4_t": "Contratos e IA",
  "lp_f4_d": "Extração de contratos com IA, gestão de prazos e cláusulas de índice de preços.",
  "lp_f5_t": "Analytics e forecasts",
  "lp_f5_d": "Dashboards ao vivo, forecasts de clientes e KPIs de gestão.",
  "lp_f6_t": "Portais e colaboração",
  "lp_f6_d": "Portais de clientes e fornecedores com acesso seguro e auditado.",
  "lp_signin_card_title": "Bem-vindo de volta",
  "lp_explore": "Descobrir funções",
  "lp_stat1_l": "Cliente 360°",
  "lp_stat2_l": "Idiomas",
  "lp_stat3_l": "Processo de qualidade",
  "lp_stat4_l": "Gestão de fornecedores",
  "hero_eyebrow": "O extraordinário esquadrão CRM",
  "hero_tagline": "Salva o teu pipeline. Derrota o caos.",
  "hero_desc": "Sete heróis. Uma missão: esmagar a perda de clientes, pulverizar os SLA e resgatar cada negócio à beira do abismo.",
  "hero_cta": "Junta-te à Force",
  "hero_p1_t": "Potência de pipeline",
  "hero_p1_d": "Atravessa o teu funil de vendas a velocidade sobre-humana.",
  "hero_p2_t": "Esmagador de reclamações",
  "hero_p2_d": "Neutraliza as ameaças de qualidade antes de escalarem.",
  "hero_p3_t": "Visão de forecast",
  "hero_p3_d": "Antecipa o futuro da receita de cada cliente.",
  "hero_meet": "Conhece a equipa",
  "visit_notes": "Notas de visita",
  "vn_record": "Gravar nota",
  "vn_recording": "A gravar…",
  "vn_stop": "Parar gravação",
  "vn_transcribing": "A transcrever…",
  "vn_analyzing": "A analisar com IA…",
  "vn_transcript": "Transcrição",
  "vn_edit_transcript": "Reveja e edite a transcrição antes de guardar (o ditado de nomes de produto pode falhar).",
  "vn_analyze_save": "Analisar e guardar",
  "vn_ai_summarize": "Resumir com IA",
  "vn_ai_summary_title": "Resumo de IA (Assistente de relatório de visita)",
  "vn_ai_apply": "Aplicar",
  "vn_language": "Idioma",
  "vn_auto": "Deteção automática",
  "vn_manual_entry": "Escrever manualmente",
  "vn_upload_email": "Carregar e-mail",
  "vn_manual_text_ph": "Escreva aqui a sua nota de visita…",
  "vn_source": "Origem",
  "vn_source_voice": "Voz",
  "vn_source_email": "E-mail",
  "vn_source_manual": "Manual",
  "vn_risk": "Classificação",
  "vn_risk_green": "Normal",
  "vn_risk_yellow": "Observar",
  "vn_risk_orange": "Risco",
  "vn_risk_red": "Escalonamento",
  "vn_partner": "Interlocutor e função",
  "vn_topics": "Temas abordados",
  "vn_agreements": "Acordos / pontos em aberto",
  "vn_competitors": "Concorrentes mencionados",
  "vn_pricing": "Temas de preço / condições",
  "vn_next_steps": "Próximos passos",
  "vn_triggers": "Temas de gatilho",
  "vn_reason": "Justificação",
  "vn_override": "Corrigir classificação",
  "vn_override_reason": "Motivo da correção (obrigatório)",
  "vn_linked_opps": "Oportunidades ligadas",
  "vn_suggested_tasks": "Tarefas sugeridas",
  "vn_create_tasks": "Criar tarefas selecionadas",
  "vn_tasks_created": "Tarefas criadas",
  "vn_assignee": "Responsável",
  "vn_no_notes": "Ainda sem notas de visita.",
  "vn_filter_all_sources": "Todas as origens",
  "vn_filter_all_risks": "Todas as classificações",
  "vn_search_ph": "Pesquisar notas… (ex.: quando se falou do preço)",
  "vn_from": "De",
  "vn_to": "Até",
  "vn_creator": "Criador",
  "vn_all_creators": "Todos os criadores",
  "vn_saved": "Nota guardada",
  "vn_show_transcript": "Mostrar transcrição",
  "vn_hide_transcript": "Ocultar transcrição",
  "vn_mic_error": "Microfone indisponível. Use entrada manual ou carregamento de e-mail.",
  "vn_reanalyze": "Reanalisar",
  "vn_corrected": "corrigido",
  "vn_new_note": "Nova nota",
  "vn_who": "Quem",
  "vn_what": "O quê",
  "vn_due": "Até quando",
  "vn_record_hint": "Toque para ditar a sua nota logo após a reunião.",
  "vn_task_subject": "Tarefa",
  "vn_add_task": "Adicionar tarefa",
  "escalation": "Escalonamento",
  "escalation_help": "Quem recebe os alertas de risco vermelho e o resumo semanal de riscos.",
  "escalation_saved": "Destinatários guardados",
  "sla_rules": "Regras de SLA",
  "sla_saved": "Regras de SLA guardadas",
  "saving": "A guardar…",
  "hours": "horas",
  "days": "dias",
  "sla_help": "Configure os limiares de nível de serviço que acionam lembretes e escalonamentos automáticos no CRM.",
  "sla_complaint_ack_hours": "Confirmação de reclamação",
  "sla_complaint_ack_hours_desc": "Horas até uma nova reclamação escalar para a direção se não for confirmada.",
  "sla_artwork_reminder_days": "Lembrete de aprovação de arte",
  "sla_artwork_reminder_days_desc": "Dias que uma arte enviada pode aguardar aprovação do cliente antes de lembrar o responsável.",
  "sla_contract_renewal_days": "Janela de renovação de contrato",
  "sla_contract_renewal_days_desc": "Dias antes do fim de um contrato em que começam os lembretes de renovação.",
  "orgchart_tab": "Organograma",
  "orgchart_title": "Mapa do buying center",
  "orgchart_subtitle": "Contactos ordenados por influência na decisão.",
  "orgchart_tier_decision": "Decisão",
  "orgchart_tier_influence": "Influência e apoio",
  "orgchart_tier_operational": "Operacional / acesso",
  "orgchart_tier_empty": "Sem contactos neste nível",
  "orgchart_no_role": "Sem função",
  "orgchart_empty": "Ainda sem contactos — adicione contactos para ver o mapa do buying center.",
  "orgchart_show_all": "Mostrar todos",
  "role_decision_maker": "Decision Maker",
  "role_champion": "Champion",
  "role_influencer": "Influencer",
  "role_gatekeeper": "Gatekeeper",
  "role_user": "User",
  "guide_desc_visit_notes": "Notas de visita com IA: dite ou carregue e-mails, obtenha resumos estruturados e uma classificação de risco de 4 níveis.",
  "ai_contract_analysis": "Análise de contrato com IA",
  "contract_summary": "Resumo",
  "contract_deviations": "Desvios vs. dados CRM",
  "no_deviations": "Nenhum desvio detetado.",
  "contract_value": "Valor do contrato",
  "crm_value": "Valor CRM",
  "deviation_match": "Corresponde",
  "deviation_deviation": "Desvio",
  "deviation_unknown": "Desconhecido",
  "severity_critical": "Crítico",
  "severity_warning": "Aviso",
  "severity_info": "Info",
  "extracted_terms": "Dados extraídos do contrato",
  "contract_parties": "Partes",
  "contract_term": "Vigência",
  "notice_period": "Prazo de aviso prévio",
  "auto_renewal": "Renovação automática",
  "pricing_conditions": "Preços e condições",
  "volume_minimum": "Volume / compra mínima",
  "liability_warranty": "Responsabilidade e garantia",
  "price_index_clauses": "Cláusulas de índice de preços",
  "upload_contract_doc": "Carregar contrato (PDF/DOCX)",
  "analyzing": "A analisar…",
  "analyzing_hint": "A extrair dados com IA — pode demorar até 30 segundos.",
  "only_pdf_docx": "Apenas PDF ou DOCX",
  "no_contract_docs": "Ainda sem documentos de contrato carregados.",
  "deviations_short": "desvios",
  "ok": "OK",
  "pages": "páginas",
  "paragraphs": "parágrafos",
  "ref_page": "pág.",
  "ref_paragraph": "par.",
  "months": "meses",
  "yes": "Sim",
  "no": "Não",
  "extraction_done": "Extração com IA concluída",
  "extraction_failed": "A extração com IA falhou",
  "confirm_delete_doc": "Eliminar este documento?",
  "deleted": "Eliminado",
  "view_original": "Ver original",
  "reextract": "Reanalisar",
  "back": "Voltar",
  "contract_deadlines": "Prazos de contratos",
  "contract_deadlines_subtitle": "Prazos de aviso prévio, renovações e expiração — com base nos dados extraídos por IA.",
  "refresh": "Atualizar",
  "urgency": "Urgência",
  "urgency_notice_missed": "Aviso prévio expirado",
  "urgency_notice_soon": "Aviso prévio em breve",
  "urgency_expired": "Expirado",
  "urgency_expiring_soon": "Expira em breve",
  "urgency_none": "OK",
  "notice_deadline": "Data de aviso prévio",
  "with_ai_analysis": "Com análise de IA",
  "no_deadlines": "Sem contratos abertos.",
  "no_notice_detected": "Nenhum prazo de aviso prévio detetado",
  "upload_for_notice": "Carregar contrato",
  "contract_data": "Dados do contrato",
  "documents": "Documentos",
  "account_analysis": "Análise de conta",
  "ai_analysis": "Análise de conta com IA",
  "wallet_share_tab": "Fábrica e Wallet Share",
  "last_generated": "Gerado pela última vez",
  "generate_now": "Gerar agora",
  "update_now": "Atualizar agora",
  "ai_never_run": "Ainda não foi gerada nenhuma análise.",
  "generating": "A gerar análise…",
  "ai_trend": "Evolução da tendência",
  "ai_sentiment": "Sentimento ao longo do tempo",
  "ai_stakeholders": "Análise de poder dos stakeholders",
  "ai_wallet": "Evolução do Wallet Share",
  "ai_risks_opps": "Fatores de risco e oportunidades",
  "ai_recommendations": "Recomendações",
  "ai_direction": "Direção",
  "dir_growing": "crescente",
  "dir_stable": "estável",
  "dir_declining": "decrescente",
  "ai_notable_jumps": "Saltos notáveis",
  "ai_no_data": "Ainda sem dados para esta secção.",
  "ai_role": "Função / influência",
  "ai_stance": "Postura em relação a nós",
  "ai_flag": "Indicador de mudança",
  "risk_label": "Risco",
  "chance_label": "Oportunidade",
  "priority_short": "Prio",
  "ext_research": "Pesquisa externa",
  "ext_research_sub": "Fontes públicas · não verificado",
  "ext_update": "Atualizar pesquisa",
  "ext_never": "Ainda sem pesquisa externa.",
  "ext_researching": "A pesquisar fontes públicas…",
  "ext_news": "Notícias da empresa",
  "ext_financials": "Situação financeira",
  "ext_strategy": "Direção estratégica",
  "ext_market_comp": "Concorrentes de mercado do cliente",
  "ext_contact_check": "Verificação de contactos",
  "ext_no_info": "Nenhuma informação pública relevante encontrada.",
  "ext_unverified": "não verificado · fonte pública",
  "ext_source": "Fonte",
  "ext_no_date": "sem data",
  "internal_verified": "verificado · registo próprio",
  "ws_plant_supply": "Fornecimento fábrica → cliente",
  "ws_add_supply": "Adicionar fornecimento",
  "ws_plant": "Fábrica",
  "ws_period": "Período",
  "ws_period_month": "Mensal",
  "ws_period_quarter": "Trimestral",
  "ws_qty": "Quantidade",
  "ws_unit": "Unidade",
  "ws_revenue": "Receita (EUR)",
  "ws_wallet": "Wallet Share (nível cliente)",
  "ws_add_wallet": "Adicionar entrada de Wallet Share",
  "ws_category": "Categoria",
  "ws_budget": "Orçamento/necessidade total (EUR)",
  "ws_our_eur": "A nossa parte (EUR)",
  "ws_our_pct": "A nossa parte %",
  "ws_comp_pct": "Parte da concorrência %",
  "ws_total_pct": "Total %",
  "ws_competitors": "Concorrentes",
  "ws_comp_name": "Concorrente",
  "ws_comp_share": "Parte %",
  "ws_comp_source": "Fonte",
  "ws_add_competitor": "Adicionar concorrente",
  "ws_over100": "A soma das partes ultrapassa 100% — verifique, por favor.",
  "ws_stale": "Os dados de Wallet Share têm mais de 6 meses — atualize-os.",
  "ws_trend": "Wallet Share ao longo do tempo",
  "ws_no_supply": "Ainda sem fornecimentos de fábrica registados.",
  "ws_no_wallet": "Ainda sem entradas de Wallet Share.",
  "ws_notes": "Notas / fonte",
  "ws_change_history": "Histórico de alterações",
  "ws_saved": "Guardado",
  "ws_deleted": "Eliminado",
  "plant_view": "Vista de fábrica",
  "plant_view_sub": "Que clientes cada fábrica abastece",
  "pv_customers": "Clientes",
  "pv_total_qty": "Quantidade total",
  "pv_total_revenue": "Receita total",
  "pv_no_data": "Ainda sem dados de fornecimento para esta fábrica.",
  "pv_select_plant": "Todas as fábricas",
  "guide_desc_plant_view": "Vista agregada de fábrica: que clientes cada fábrica abastece e com que volume.",
  "analysis_pdf": "PDF de análise (QBR)",
  "access_denied_intel": "Apenas vendas, KAM e direção podem ver estes dados.",
  "language": "Idioma",
  "lang_en": "Inglês",
  "lang_de": "Alemão",
  "lang_es": "Espanhol",
  "lang_pt": "Português",
  "lang_it": "Italiano",
  "translate": "Traduzir",
  "translating": "A traduzir…",
  "show_original": "Ver original",
  "translated_hint": "Tradução por IA — os termos técnicos (Wallet Share, OTIF, SLA…) permanecem em inglês.",
  "faq": "FAQ",
  "faq_title": "Perguntas frequentes",
  "faq_subtitle": "Respostas rápidas às perguntas mais comuns sobre o Encasa CRM & SRM.",
  "faq_intro": "Não encontra o que procura? Repita a visita guiada ou abra um guia de módulo acima.",
  "guide_faq_card": "FAQ",
  "guide_desc_faq": "Respostas a perguntas frequentes sobre funções, contratos, forecasts, idiomas e funcionalidades de IA.",
  "guide_getting_started": "Primeiros passos",
  "guide_gs_intro": "Quatro passos rápidos para ser produtivo desde o primeiro dia.",
  "guide_gs_1_t": "1 · Encontre tudo rapidamente",
  "guide_gs_1_d": "Use a barra de pesquisa global no topo para saltar para qualquer cliente, contacto, oportunidade, proposta ou reclamação.",
  "guide_gs_2_t": "2 · Trabalhe os seus clientes",
  "guide_gs_2_d": "Abra um cliente para a vista 360° — hierarquia, KPIs, contratos, notas de visita e análise de IA num só lugar.",
  "guide_gs_3_t": "3 · Antecipe-se aos prazos",
  "guide_gs_3_d": "A campainha de notificações e a página Prazos de contratos mostram incumprimentos de SLA, renovações e prazos de aviso prévio.",
  "guide_gs_4_t": "4 · Trabalhe no seu idioma",
  "guide_gs_4_d": "Mude a interface entre PT/EN/DE/ES/IT quando quiser através do seletor de idioma na barra superior.",
  "guide_more_help": "Precisa de mais ajuda?",
  "guide_open_faq": "Abrir FAQ",
  "guide_desc_my_access": "Veja a sua função, permissões de campo, contas visíveis e substituições ativas.",
  "faq_q1": "Como funcionam as funções e permissões?",
  "faq_a1": "Cada utilizador tem uma função (admin, chefe de vendas, comercial, serviço ao cliente, só leitura) mais um perfil de permissões opcional. Estes decidem que contas vê, se vê dados comerciais (receita, margens, Wallet Share) e se pode editar. Consulte os seus direitos na página «Meus direitos».",
  "faq_q2": "Preciso de trabalhar na conta de um colega. Como obtenho acesso?",
  "faq_a2": "Um admin ou chefe de vendas pode conceder-lhe um acesso temporário de substituição (ex.: por férias) ou uma exceção pontual em Administração → Acesso e substituição. As permissões têm data de início/fim e expiram automaticamente.",
  "faq_q3": "Como funciona a análise de contratos com IA?",
  "faq_a3": "Abra um contrato, vá ao separador Documentos e carregue um PDF ou DOCX. O GPT-4o extrai a vigência, o prazo de aviso prévio, a renovação automática, os preços e as cláusulas de índice — cada um com referência de página/parágrafo — e assinala desvios face aos seus dados CRM. Nunca altera os seus dados; apenas reporta.",
  "faq_q4": "O que significam as urgências dos prazos de contratos?",
  "faq_a4": "«Aviso prévio expirado» = o prazo de cancelamento passou; «Aviso prévio em breve» = nos próximos 30 dias; «Expira em breve» = termina em 90 dias; «Expirado» = data de fim ultrapassada. Baseiam-se no aviso prévio extraído por IA, por isso carregue o documento do contrato para os ativar.",
  "faq_q5": "Como funcionam os forecasts e as aprovações?",
  "faq_a5": "Introduza o forecast mensal vs. real por cliente e projeto. Os comerciais submetem um forecast do ano fiscal para aprovação; os chefes de vendas aprovam ou rejeitam na fila Aprovações de forecast. Forecasts aprovados contam como comprometidos; editá-los repõe-nos em rascunho para nova aprovação.",
  "faq_q6": "Que idiomas são suportados e como mudo?",
  "faq_a6": "A interface está disponível em português, inglês, alemão, espanhol e italiano. Use o seletor de idioma na barra superior — a sua escolha é memorizada neste dispositivo. Termos técnicos como Wallet Share, OTIF, SLA e QBR permanecem propositadamente em inglês.",
  "faq_q7": "Posso traduzir uma nota ou resumo escrito noutro idioma?",
  "faq_a7": "Sim. Os resumos gerados por IA (análise de contrato, análise de conta, notas de visita) mostram um link «Traduzir» que apresenta o texto no idioma atual da interface a pedido e permite voltar ao original.",
  "faq_q8": "Como funcionam as reclamações, o 8D e o seguimento de SLA?",
  "faq_a8": "As reclamações recebem um número REK automático e um SLA de confirmação. Se não forem confirmadas a tempo, escalam para a direção. Registe o relatório 8D (D1–D8) e os custos e envie o PDF 8D ao cliente diretamente a partir da reclamação por e-mail.",
  "faq_q9": "Como exporto dados?",
  "faq_a9": "A maioria das listas oferece exportação/importação CSV. O construtor de relatórios exporta para Excel (XLSX). Scorecards, pacotes QBR e a análise de conta exportam para PDF a partir dos respetivos ecrãs.",
  "faq_q10": "O que significam os níveis de risco das notas de visita?",
  "faq_a10": "Depois de ditar ou carregar uma nota, a IA classifica-a como Normal (verde), Observar (amarelo), Risco (laranja) ou Escalonamento (vermelho). O laranja notifica o responsável da conta; o vermelho também alerta os destinatários de escalonamento. Pode corrigir a classificação com um motivo obrigatório.",
  "translations_tab": "Traduções",
  "tr_help": "Substitua qualquer texto da interface por idioma. Um valor vazio restaura a tradução incorporada. As alterações aplicam-se instantaneamente a todos os utilizadores.",
  "tr_no_overrides": "Ainda sem overrides — pesquise uma chave acima para personalizar um texto.",
  "guide_manual": "Manual",
  "guide_search_ph": "Procurar uma função…",
  "guide_update_btn": "Atualizar manual",
  "guide_updating": "A atualizar…",
  "guide_last_updated": "Última atualização",
  "guide_up_to_date": "Atualizado",
  "guide_generating": "O manual está a ser gerado — o conteúdo vai melhorar em breve.",
  "guide_sec_purpose": "Para quê?",
  "guide_sec_steps": "Passo a passo",
  "guide_sec_tips": "Dicas",
  "guide_sec_roles": "Perfis e permissões",
  "guide_select_prompt": "Selecione um tema à esquerda para ler o guia.",
  "guide_no_results": "Nenhuma função encontrada.",
  "guide_ai_badge": "Gerado por IA",
  "guide_all_topics": "Todos os temas",
  "guide_whats_new": "Novidades",
  "guide_new_badge": "Novo",
  "guide_whats_new_empty": "Ainda sem novidades."
};
export default dict;
